// src/components/delivery/DeliveryLayout.jsx
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, Outlet } from "react-router-dom";
import DeliveryHeader from "./DeliveryHeader";

const DeliveryLayout = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useSelector((state) => state.delivery);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/delivery/login");
    }
  }, [isAuthenticated, navigate]);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gray-50 font-nunito">
      <DeliveryHeader />
      <main className="container mx-auto px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
};

export default DeliveryLayout;
